export const analyticsComparisonMessages = {
  periodComparison: 'Period Comparison',
  periodComparisonSubtitle: 'Selected range compared with the preceding equal-length period',
  currentPeriod: 'Current',
  previousPeriod: 'Previous',
  newTraffic: 'New',
  previousSeries: 'Previous period total',
  activityHeatmap: 'Activity Heatmap',
  activityHeatmapSubtitle: 'Visits by local weekday and hour',
  peakActivity: 'Peak: {day} {hour} · {count} visits',
  visitsAtTime: '{day} {hour}: {count} visits, {human} human, {bots} bots',
  lessTraffic: 'Less',
  moreTraffic: 'More',
} as const;
